/**
 * 全站权限配置
 *
 */
import router from './router';
import store from './store';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { validatenull } from '@/utils/validate';
// import Cookies from 'js-cookie';
import { pendingRequest } from './api/axios';

NProgress.configure({ showSpinner: false });
router.beforeEach((to, form, next) => {
  pendingRequest.forEach((item) => {
    item.routeChangeCancel && item.cancel();
  });

  NProgress.start();
  const value = to.query.src || to.fullPath;
  const label = to.query.name || to.name;
  const meta = to.meta || {};
  if (meta.isTab !== false && !validatenull(value) && !validatenull(label)) {
    store.commit('ADD_TAG', {
      label: label,
      value: value,
      params: to.params,
      query: to.query,
    });
  }
  if (to.path == '/login') {
    store.commit('DEL_ALL_TAG');
  }
  next();
});

router.afterEach(() => {
  NProgress.done();
});
